export default "__VITE_ASSET__98aa1a5b__"